import React from 'react';
import { useTranslation } from 'react-i18next';
import Box from '../../Components/Layout/Box';
import { GetWebCurrentUser_currentUser } from '../../GraphQL';
import { useForm } from 'react-hook-form';
import SearchableSelect from '@ssg/common/Components/SearchableSelect';
import { useSearchWebUsersQuery, useSetUserProxyMutation } from '@ssg/common/GraphQL/indexV2';
import useDebouncedState from '@ssg/common/Hooks/useDebouncedState';
import { SelectOption } from '@ssg/common/Helpers/Helpers';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/pro-regular-svg-icons';

interface Props {
	user: GetWebCurrentUser_currentUser;
}

const ProxyUserBox: React.FC<Props> = ({ user }) => {
	const { t } = useTranslation();
	const dummyForm = useForm();
	const [caseWorkerSearchText, setCaseWorkerSearchText] = useDebouncedState(user.proxy?.name ?? '', 100);
	const [myProxy, setMyProxy] = React.useState<SelectOption | undefined>(
		user.proxy
			? {
					value: user.proxy.id,
					label: user.proxy.name,
			  }
			: undefined,
	);
	const { loading: cmLoading, data: cmData } = useSearchWebUsersQuery({
		variables: {
			searchText: caseWorkerSearchText,
			onlyEmployees: true,
		},
		skip: caseWorkerSearchText === '',
	});

	const [postSetUserProxy, { loading: postSetUserProxyLoading }] = useSetUserProxyMutation();

	const searchCaseWorkerSelectHandler = async (value: string) => {
		await postSetUserProxy({
			variables: {
				proxyAdUserName: value,
				myAdUserName: user.id,
				proxySetByAdUserName: user.id,
			},
			onCompleted: data => {
				if (data.setUserProxy) {
					setMyProxy({ value: data.setUserProxy.id, label: data.setUserProxy.name });
				}
			},
		});
	};

	const cmUsers = React.useMemo(() => {
		return cmData?.searchUsers.map((d): SelectOption => ({ value: d.id, label: d.name }));
	}, [cmData]);
	return (
		<Box title="myPage.proxyTitle" className="text-blue">
			<label className="block text-xs font-medium">{t('myPage.myProxy')}</label>
			{/* {myProxy ? <p>{myProxy.label}</p> : t('myPage.noProxyActive')} */}
			<div className="relative">
				<SearchableSelect
					control={dummyForm.control}
					name="myProxy"
					title=""
					options={cmUsers ?? []}
					searchFn={(searchText): void => setCaseWorkerSearchText(searchText)}
					onSelect={async value => await searchCaseWorkerSelectHandler(value)}
					onBlur={(clearFn): void => undefined}
					minInputLength={2}
					isLoading={cmLoading}
					initialSelection={myProxy}
					placeholder={t('myPage.noProxyActive')}
					readOnly={postSetUserProxyLoading}
				/>
				{postSetUserProxyLoading && (
					<div className="mt-2 text-xs absolute top-0 right-0 mr-2 pl-2 bg-gray-300">
						<FontAwesomeIcon icon={faSpinner} spin /> Gemmer ...
					</div>
				)}
			</div>
			<div className="mt-4">
				<label className="block text-xs font-medium">{t('myPage.proxyFor')}</label>
				<p>{user.proxyFor.length > 0 ? user.proxyFor.map(proxy => <p>{proxy.name}</p>) : <p>{t('myPage.none')}</p>}</p>
			</div>
		</Box>
	);
};

export default ProxyUserBox;

